const actions = {
  PARTNER_ADD_BEGIN: 'PARTNER_ADD_BEGIN',
  PARTNER_ADD_SUCCESS: 'PARTNER_ADD_SUCCESS',
  PARTNER_ADD_ERR: 'PARTNER_ADD_ERR',
  
  PARTNERS_READ_BEGIN: 'PARTNERS_READ_BEGIN',
  PARTNERS_READ_SUCCESS: 'PARTNERS_READ_SUCCESS',
  PARTNERS_READ_ERR: 'PARTNERS_READ_ERR',

  PARTNER_UPDATE_BEGIN: 'PARTNER_UPDATE_BEGIN',
  PARTNER_UPDATE_SUCCESS: 'PARTNER_UPDATE_SUCCESS',
  PARTNER_UPDATE_ERR: 'PARTNER_UPDATE_ERR',

  PARTNER_DELETE_BEGIN: 'PARTNER_DELETE_BEGIN',
  PARTNER_DELETE_SUCCESS: 'PARTNER_DELETE_SUCCESS',
  PARTNER_DELETE_ERR: 'PARTNER_DELETE_ERR',

  PARTNER_READ_BEGIN: 'PARTNER_READ_BEGIN',
  PARTNER_READ_SUCCESS: 'PARTNER_READ_SUCCESS',
  PARTNER_READ_ERR: 'PARTNER_READ_ERR',

  PARTNER_UPLOAD_BEGIN: 'PARTNER_UPLOAD_BEGIN',
  PARTNER_UPLOAD_SUCCESS: 'PARTNER_UPLOAD_SUCCESS',
  PARTNER_UPLOAD_ERR: 'PARTNER_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.PARTNERS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.PARTNERS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.PARTNERS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.PARTNER_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.PARTNER_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.PARTNER_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.PARTNER_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.PARTNER_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.PARTNER_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.PARTNER_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.PARTNER_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.PARTNER_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.PARTNER_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.PARTNER_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.PARTNER_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.PARTNER_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.PARTNER_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.PARTNER_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
